import axios from "axios";
import appState from "../state/AppStateContainer";

export type EmailPreviewType = "bidRequest" | "dateChange" | "erfa" | "contractSignature" | "evaluation" | "evaluationReceipt";

export type EmailPreviewParams = {
  recipientName?: string,
  areaName?: string,
  projectName?: string,
  projectNumber?: string,
  supplierName?: string,
  title?: string,
  expiryDate?: string,
  versionNo?: number | null,
  dueDate?: string,
};

class ServiceEmailPreviewController {
  async getPreview(type: EmailPreviewType, params: EmailPreviewParams) {
    const orgSlug = appState.getCurrentOrgSlug();
    const response = await axios.post(`/api/organizations/${orgSlug}/email/preview`, { type, params });
    return response.data as { html: string };
  }
}

export const ServiceEmailPreview = new ServiceEmailPreviewController();
